export class Product {
    constructor(
        public readonly id: number,
        public readonly name: string
    ) {}

    static fromAPI(data: { id: number; produto: string }): Product {
        return new Product(data.id, data.produto);
    }
}

